import React from "react";
import { useParams } from "react-router-dom";
import { EvtHeader } from "components/header";
import ChallengeForm from "./form";

const CreateChallenge = () => {
  const { jobId } = useParams();
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Add Challenge" />
      <div className="p-6 max-w-2xl">
        <ChallengeForm jobId={jobId} />
      </div>
    </div>
  );
};

export default CreateChallenge;
